$(() => {
    
    // Submit gated form
	$('.gated-form-submit').on('click', event => {
		event.preventDefault()

		const form = $('#gated-form')

		if (!form.length) {
            return false
        }

		form.trigger('submit')
	}) 

	// Scroll to gated form if it has errors
	if ($('.gated-form.has-errors').length) {
		$('html, body').animate({
			scrollTop: $('.gated-form.has-errors form').offset().top - 100,
		}, 0)
	}
})